<template>
  <div class="bndbs-toast-host" dir="rtl">
    <transition-group name="bndbs-toast">
      <div
        v-for="t in items"
        :key="t.id"
        class="toast show align-items-center border-0 mb-2"
        :class="'text-bg-' + t.type"
        role="alert"
        aria-live="assertive"
        aria-atomic="true"
      >
        <div class="d-flex">
          <div class="toast-body">
            <strong v-if="t.title" class="d-block">{{ t.title }}</strong>
            <span>{{ t.msg }}</span>
          </div>
          <button
            type="button"
            class="btn-close btn-close-white me-2 m-auto"
            aria-label="بستن"
            @click="remove(t.id)"
          ></button>
        </div>
      </div>
    </transition-group>
  </div>
</template>

<script>
import { toastState, removeToast } from "@/plugins/toastr";

export default {
  name: "ToastHost",
  computed: {
    items() {
      return toastState.items;
    },
  },
  methods: {
    remove(id) {
      removeToast(id);
    },
  },
};
</script>

<style scoped>
.bndbs-toast-host {
  position: fixed;
  bottom: 1rem;
  left: 1rem;
  z-index: 100050;
  width: 320px;
  max-width: calc(100vw - 2rem);
  pointer-events: none;
}
.bndbs-toast-host .toast {
  pointer-events: auto;
  width: 100%;
}
.bndbs-toast-enter-active,
.bndbs-toast-leave-active {
  transition: all 0.25s ease;
}
.bndbs-toast-enter-from,
.bndbs-toast-leave-to {
  opacity: 0;
  transform: translateY(12px);
}
</style>
